{
  "id": 35,
  "location": "paris",
  "difficulty": "hard",
  "moves": 25,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "croissant", "count": 36 }
  ],
  "stars": [4330, 5570],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    "x x x x x x x x",
    "X X X X X X X X",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.413, "movesLeft": 3.4, "closeLosses": 0.21, "target": 0.42 }
}
